var _a;
import { __decorate, __extends } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import SliderHelper from '../../slider-helper';
import { breakpoints } from "../../breakpoint-constants";
import { Glide, GlideSlide } from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentSlideIndex = _this.startAt;
        _this.nextSlideIndex = null;
        _this.lastSlideIndex = null;
        _this.slideCount = null;
        _this.slidesToShow = null;
        _this.dots = false;
        _this.images = null;
        _this.arrows = true;
        _this.infinite = false;
        _this.setupCreated = false;
        _this.glideOptions = null;
        return _this;
    }
    Slider.prototype.created = function () {
        var _this = this;
        var slot = this.$slots.default;
        if (slot) {
            slot.map(function (x, i) {
                _this.$slots.default[i] = _this.$createElement('vue-glide-slide', [_this.$slots.default[i]]);
            });
            this.slideCount = this.$slots.default.length;
            this.lastSlideIndex = this.slideCount - 1;
        }
        this.images = this.$slots.default;
        if (breakpoints().breakpoints.desktop) {
            this.arrows = this.arrowsDesktop;
            this.dots = this.dotsDesktop;
            this.infinite = this.infiniteDesktop;
        }
        if (breakpoints().breakpoints.tablet) {
            this.dots = this.dotsTablet;
            this.arrows = this.arrowsTablet;
            this.infinite = this.infiniteTablet;
            this.autoplay = false;
        }
        if (breakpoints().breakpoints.mobile) {
            this.dots = this.dotsMobile;
            this.arrows = this.arrowsMobile;
            this.infinite = this.infiniteMobile;
            this.autoplay = false;
        }
        this.glideOptions = {
            type: this.infinite ? 'carousel' : 'slider',
            perView: 1,
            startAt: this.startAt,
            gap: this.gap,
            animationDuration: this.speed,
            autoplay: this.autoplay,
            hoverpause: this.hoverpause,
            focusAt: this.focusAt,
            perTouch: 1,
            breakpoints: {
                99999: {
                    type: this.infiniteDesktop ? 'carousel' : 'slider',
                    perView: this.slidesToShowDesktop,
                    rewind: this.rewind !== null ? this.rewind : this.infiniteDesktop,
                    bound: !this.infiniteDesktop,
                },
                1280: {
                    type: this.infiniteDesktop ? 'carousel' : 'slider',
                    perView: this.slidesToShowDesktopSmall,
                    rewind: this.rewind !== null ? this.rewind : this.infiniteDesktop,
                    bound: !this.infiniteDesktop,
                },
                1023: {
                    type: this.infiniteTablet ? 'carousel' : 'slider',
                    perView: this.slidesToShowTablet,
                    rewind: this.rewind !== null ? this.rewind : this.infiniteTablet,
                    bound: !this.infiniteTablet
                },
                767: {
                    type: this.infiniteMobile ? 'carousel' : 'slider',
                    perView: this.slidesToShowMobile,
                    rewind: this.rewind !== null ? this.rewind : this.infiniteMobile,
                    bound: !this.infiniteMobile
                },
            },
        };
        var options = this.match(this.glideOptions.breakpoints);
        this.slidesToShow = options.perView;
        this.setupCreated = true;
    };
    Slider.prototype.mounted = function () {
        if (this.loadingClass !== '') {
            var loadingElement = document.querySelector('.' + this.loadingClass);
            loadingElement.remove();
        }
        if (this.goToSelected) {
            this.jumpToSelected();
        }
        //@ts-ignore
        var slider = this.$refs.glide.$el;
        slider.querySelectorAll('[data-glide-index="' + this.lastSlideIndex + '"]').forEach(function (item) {
            var child = item.firstElementChild;
            child.style.display = 'block';
            SliderHelper.insertLazyImages(item);
        });
    };
    Slider.prototype.match = function (points) {
        if (typeof window.matchMedia !== 'undefined') {
            for (var point in points) {
                if (points.hasOwnProperty(point)) {
                    if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) {
                        return points[point];
                    }
                }
            }
        }
        return null;
    };
    Slider.prototype.handleInit = function (event) {
        var options = this.match(this.glideOptions.breakpoints);
        if (options) {
            //@ts-ignore
            var slider = this.$refs.glide.$el;
            for (var i = this.currentSlideIndex; i <= this.currentSlideIndex + options.perView; i++) {
                slider.querySelectorAll('[data-glide-index="' + i + '"]').forEach(function (item) {
                    var child = item.firstElementChild;
                    child.style.display = 'block';
                    SliderHelper.insertLazyImages(item);
                });
            }
        }
    };
    Slider.prototype.handleBeforeChange = function (data) {
        if (data.direction === '=') {
            this.currentSlideIndex = parseInt(data.steps);
        }
        else {
            if (data.direction === '>') {
                if ((!this.infiniteDesktop && this.currentSlideIndex + (this.slidesToShow - 1) < this.lastSlideIndex) || this.infiniteDesktop) {
                    this.currentSlideIndex++;
                    this.nextSlideIndex = this.currentSlideIndex + this.slidesToShow;
                    if (this.infiniteDesktop) {
                        if (this.currentSlideIndex > this.lastSlideIndex) {
                            this.currentSlideIndex = 0;
                        }
                        if (this.nextSlideIndex > this.lastSlideIndex) {
                            this.nextSlideIndex = 0;
                        }
                    }
                }
            }
            else {
                if ((!this.infiniteDesktop && this.currentSlideIndex > 0) || this.infiniteDesktop) {
                    this.currentSlideIndex--;
                    this.nextSlideIndex = this.currentSlideIndex - 1;
                    if (this.infiniteDesktop) {
                        if (this.currentSlideIndex < 0) {
                            this.currentSlideIndex = this.lastSlideIndex;
                        }
                        if (this.nextSlideIndex < 0) {
                            this.nextSlideIndex = this.lastSlideIndex;
                        }
                    }
                }
            }
        }
        //@ts-ignore
        var slider = this.$refs.glide.$el;
        slider.querySelectorAll('[data-glide-index="' + this.currentSlideIndex + '"]').forEach(function (item) {
            var child = item.firstElementChild;
            child.style.display = 'block';
            SliderHelper.insertLazyImages(item);
        });
        slider.querySelectorAll('[data-glide-index="' + this.nextSlideIndex + '"]').forEach(function (item) {
            var child = item.firstElementChild;
            child.style.display = 'block';
            SliderHelper.insertLazyImages(item);
        });
    };
    Slider.prototype.lazyLoadNextImages = function (direction, index) {
        //@ts-ignore
        var slider = this.$refs.glide.$el;
        var options = this.match(this.glideOptions.breakpoints);
        var visibleSlideCount = options.perView;
        var nextLoadIndex = null;
        if (direction === '>') {
            for (var i = 1; i <= visibleSlideCount; i++) {
                nextLoadIndex = index + i % this.slideCount;
                slider.querySelectorAll('[data-glide-index="' + nextLoadIndex + '"]').forEach(function (item) {
                    var child = item.firstElementChild;
                    child.style.display = 'block';
                    SliderHelper.insertLazyImages(item);
                });
            }
        }
        else {
            for (var i = 1; i <= visibleSlideCount; i++) {
                nextLoadIndex = index - i % this.slideCount;
                slider.querySelectorAll('[data-glide-index="' + nextLoadIndex + '"]').forEach(function (item) {
                    var child = item.firstElementChild;
                    child.style.display = 'block';
                    SliderHelper.insertLazyImages(item);
                });
            }
        }
    };
    Slider.prototype.jumpToSelected = function () {
        var options = this.match(this.glideOptions.breakpoints);
        var slidesToShow = options.perView;
        var slideCount = this.lastSlideIndex;
        var midOfSlideWindow = Math.ceil(slidesToShow / 2);
        var goToSlide = 0;
        if (!(this.selectedSlide <= midOfSlideWindow)) {
            if (slideCount - this.selectedSlide < slidesToShow - midOfSlideWindow) {
                goToSlide = slideCount - slidesToShow;
            }
            else {
                goToSlide = this.selectedSlide - midOfSlideWindow;
            }
        }
        //@ts-ignore
        var slider = this.$refs.glide;
        //@ts-ignore
        slider.go('=' + parseInt(goToSlide));
    };
    Slider.prototype.handler = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    Slider.prototype.prev = function (e) {
        e.preventDefault();
        e.stopPropagation();
        //@ts-ignore
        var slider = this.$refs.glide;
        //@ts-ignore
        slider.go('<');
    };
    Slider.prototype.next = function (e) {
        e.preventDefault();
        e.stopPropagation();
        //@ts-ignore
        var slider = this.$refs.glide;
        //@ts-ignore
        slider.go('>');
    };
    __decorate([
        Prop()
    ], Slider.prototype, "countdown", void 0);
    __decorate([
        Prop({ default: 3 })
    ], Slider.prototype, "slidesToShowDesktop", void 0);
    __decorate([
        Prop({ default: 3 })
    ], Slider.prototype, "slidesToShowDesktopSmall", void 0);
    __decorate([
        Prop({ default: 1 })
    ], Slider.prototype, "slidesToShowTablet", void 0);
    __decorate([
        Prop({ default: 1 })
    ], Slider.prototype, "slidesToShowMobile", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "arrowsDesktop", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "arrowsTablet", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "arrowsMobile", void 0);
    __decorate([
        Prop({ default: true })
    ], Slider.prototype, "dotsMobile", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "dotsTablet", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "dotsDesktop", void 0);
    __decorate([
        Prop({ default: '' })
    ], Slider.prototype, "arrowModifier", void 0);
    __decorate([
        Prop({ default: '' })
    ], Slider.prototype, "arrowIconModifier", void 0);
    __decorate([
        Prop({ default: true })
    ], Slider.prototype, "infiniteDesktop", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "infiniteTablet", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "infiniteMobile", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "controlArrows", void 0);
    __decorate([
        Prop({ default: '' })
    ], Slider.prototype, "controlModifier", void 0);
    __decorate([
        Prop({ default: '' })
    ], Slider.prototype, "slickModifier", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "showPaging", void 0);
    __decorate([
        Prop({ default: 300 })
    ], Slider.prototype, "speed", void 0);
    __decorate([
        Prop({ default: 0 })
    ], Slider.prototype, "selectedSlide", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "goToSelected", void 0);
    __decorate([
        Prop({ default: 30 })
    ], Slider.prototype, "gap", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "autoplay", void 0);
    __decorate([
        Prop({ default: false })
    ], Slider.prototype, "hoverpause", void 0);
    __decorate([
        Prop({ default: null })
    ], Slider.prototype, "rewind", void 0);
    __decorate([
        Prop({ default: 0 })
    ], Slider.prototype, "focusAt", void 0);
    __decorate([
        Prop({ default: '' })
    ], Slider.prototype, "loadingClass", void 0);
    __decorate([
        Prop({ default: 0 })
    ], Slider.prototype, "startAt", void 0);
    Slider = __decorate([
        Component({
            components: (_a = {},
                _a[Glide.name] = Glide,
                _a[GlideSlide.name] = GlideSlide,
                _a)
        })
    ], Slider);
    return Slider;
}(Vue));
export default Slider;
